import React from "react";
import styles from "./PrivateQuotationItem.module.scss";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Cuboid, Settings, Pencil, Trash2, Eye } from "lucide-react";

const PrivateQuotationItem = ({ quotation, onOpen, onManage, onEdit, onDelete, myPerson }) => {

    const navigate = useNavigate();

    const handleManageQuotation = () => {
        const manageHandler = onManage || onOpen;
        if (manageHandler) {
            manageHandler(quotation);
            return;
        }
        if (myPerson) {
            navigate(`/cotizaciondemateriales/${quotation.id}`);
        } else {
            navigate(`/cotizaciondemateriales/postulante/${quotation.id}`);
        }
    };

    const handleEditQuotation = () => {
        if (onEdit) {
            onEdit(quotation);
            return;
        }
        navigate(`/cotizaciondemateriales/edit/${quotation.id}`);
    };

    const handleDeleteQuotation = () => {
        if (onDelete) {
            onDelete(quotation);
        }
    };

    const manageButtonLabel = myPerson ? "Gestionar" : "Ver detalles";
    const manageButtonIcon = myPerson ? <Settings size={16} /> : <Eye size={16} />;

    const formatDate = (date) => {
        const utcDate = new Date(date);
        const options = { day: 'numeric', month: 'short' };
        return utcDate.toLocaleDateString('es-ES', options);
    };

    const zoneToShow = quotation?.zone ? quotation?.zone : quotation?.jurisdiccion?.name;

    const extractMaterialsCategories = () => {
        const categories = new Set();

        quotation?.subquotation[0]?.subQuotation_materials?.forEach(item => {
            const categoryName = item?.material?.category?.name;
            if (categoryName) {
                categories.add(categoryName);
            }
        });
        return Array.from(categories);
    };

    return (
        <div className={styles.container}>
            <div className={styles.container_header}>
                <div className={styles.container_header_leftSide}>
                    <div className={styles.container_header_leftSide_titleContainer}>
                        <h2 className={styles.container_header_title}>{quotation?.name}</h2>
                        <span className={`${styles.container_header_activeStatus} ${quotation?.active && styles.container_header_activeStatus_active}`}>
                            {quotation.active ? "En proceso" : "Vencida"}
                        </span>
                    </div>
                    {quotation?.description && <p className={styles.container_header_description}>{quotation?.description}</p>}
                </div>
                <div className={styles.container_header_rightSide}>
                    <div className={styles.container_header_rightSide_currency}>
                        <span className={styles.container_header_rightSide_currency_info}>Moneda:</span>
                        <span className={styles.container_header_rightSide_currency_value}>{quotation?.currency || "ARS"}</span>
                    </div>
                    <div className={styles.container_header_rightSide_jurisdiction}>
                        <span className={styles.container_header_rightSide_jurisdiction_value}>{zoneToShow}</span>
                    </div>
                </div>
            </div>
            <div className={styles.container_body}>
                <div className={styles.container_body_box}>
                    <div className={styles.container_body_box_title}>Categoría</div>
                    <div className={styles.container_body_box_categoryContainer}>
                        {extractMaterialsCategories().map((category, index) => (
                            <div key={index} className={styles.container_body_box_category}>
                                <span className={styles.container_body_box_category_icon}>
                                    <Cuboid size={16} />
                                </span>
                                {category}
                            </div>
                        ))}
                    </div>
                </div>
                <div className={styles.container_body_box}>
                    <div className={styles.container_body_box_title}>Cantidad</div>
                    <div className={styles.container_body_box_value}>{quotation?.subquotation[0]?.subQuotation_materials?.length || 0} Materiales</div>
                </div>
                <div className={styles.container_body_box}>
                    <div className={styles.container_body_box_title}>Fecha de inicio</div>
                    <div className={styles.container_body_box_value}>{formatDate(quotation?.startDate)}</div>
                </div>
                <div className={styles.container_body_box}>
                    <div className={styles.container_body_box_title}>Fecha de fin</div>
                    <div className={styles.container_body_box_value}>{formatDate(quotation?.endDate)}</div>
                </div>
            </div>
            <div className={styles.container_footer}>
                {myPerson && (
                    <div className={styles.container_footer_actions}>
                        <button className={`${styles.actionButton} ${styles.actionButton_edit}`} type="button" onClick={handleEditQuotation}>
                            <Pencil size={16} />
                            Editar
                        </button>
                        <button className={`${styles.actionButton} ${styles.actionButton_delete}`} type="button" onClick={handleDeleteQuotation}>
                            <Trash2 size={16} />
                            Eliminar
                        </button>
                    </div>
                )}
                <button className={styles.container_button} type="button" onClick={handleManageQuotation}>
                    {manageButtonIcon}
                    <span>{manageButtonLabel}</span>
                </button>
            </div>
        </div>
    );
};


export default connect(null)(PrivateQuotationItem);
